/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.LogisticsProviderResponseDto>>;
export function request(
  params: API.tms.logisticsProvider.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsProvider/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
